function EventDateCell(date) {
  const eventDate = new Date(date);

  const options = {
    weekday: "short",
    month: "numeric",
    day: "numeric",
    year: "2-digit",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  const formattedDate = eventDate.toLocaleString("en-US", options)
    .replace(/(?<=\b)(Mon|Tue|Wed|Thu|Fri|Sat|Sun)(?=\b)/g, match => {
      switch (match) {
        case "Mon":
          return "Mo";
        case "Tue":
          return "Tu";
        case "Wed":
          return "We";
        case "Thu":
          return "Th";
        case "Fri":
          return "Fr";
        case "Sat":
          return "Sa";
        case "Sun":
          return "Su";
        default:
          return match;
      }
    })
    .replace(",", "") // Remove the comma after the weekday
    .replace(/,\s/g, " ") // Remove the comma after the date
    .replace(/\//g, "-") // Replace '/' with '-'
    .replace(/\b0/g, "") // Remove leading zeros from the date
    .replace(":0 ", " "); // Remove the minutes part when it's an oclock time

  return formattedDate;
}

export default EventDateCell;